import useCheckLoadedAndShowSPA from '../hooks/useCheckLoadedAndShowSPA';
export function useSocialSecurity() {
    useCheckLoadedAndShowSPA();
}
